export default __webpack_public_path__ + "static/6.5 - 4-8d2faa90950b659dacb04b0c787c15e2.png";